"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropLast = void 0;

var _curry = require("../curry/curry");

var _dropLast = (0, _curry.curry)(function (count, source) {
  return count > source.length ? [] : source.slice(0, source.length - count);
});
/**
 * Remove elements from end of array
 *
 * @param {number} count  Number of element to remove (default 1)
 * @param {Array}  source Source array
 *
 * @return {Array}
 *
 * @tag Array
 * @signature (count: number, source: Array): Array
 * @signature (source: Array): Array
 */


var dropLast = function dropLast(count) {
  if (Array.isArray(count)) {
    return _dropLast(1, count);
  }

  return _dropLast(count);
};

exports.dropLast = dropLast;